import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import moment from 'moment'
import numeral from 'numeral';
import 'numeral/locales/de'
import {
  Grid, Button, TextField,
  TableContainer,
  Table,
  MenuItem,
  TableCell,
  TableRow,
  TableBody,
} from '@material-ui/core';
import { GetMonthPlans, GetMonthPlansPDF, GetMonthPlanSheet } from './monthPlanAction';
import OverLoader from '../../components/common/loader';
import { LogoutAction } from '../../actions';
import globalAxios from '../../util/Api';

numeral.locale('de');


class MontPlans extends Component {

  state = {
    monthPlans: '',
    userData: '',
    reportSelect: "dayssold",
    monthPlanPdf: "",
    monthPlanSheet: ''
  }


  componentDidMount = () => {
    const { GetMonthPlans } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    if (Number(access_rights.months_plan) !== 0)
      GetMonthPlans(this.state.reportSelect)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { month_plans, user_data, month_plan_pdf, month_plan_sheet } = this.props
    if (nextProps.month_plans !== month_plans) {
      // let values = Object.values(nextProps.month_plans)
      // let data = {}
      // data[0] = values[1]
      // data[1] = values[0]
      this.setState({ monthPlans: nextProps.month_plans, userData: nextProps.user_data })
    }
    if (nextProps.user_data !== user_data) {
      this.setState({ userData: nextProps.user_data })
    }
    if (nextProps.month_plan_pdf !== month_plan_pdf) {
      this.setState({ monthPlanPdf: nextProps.month_plan_pdf })
    }

    if (nextProps.month_plan_sheet !== month_plan_sheet) {
      this.setState({ monthPlanSheet: nextProps.month_plan_sheet })
    }
  }

  plansData = (data, projectPlans) => {
    const { reportSelect } = this.state
    let newdata = ""
    projectPlans.forEach(element => {
      if (element[1][0].user_month_name === data[0].code) {
        if (reportSelect === "dayssold") {
          newdata = element[1][0].dayssold
        } else {
          newdata = element[1][0].daysassigned
        }
      }
    })
    return (
      <TableCell key={data[0].code} className="light-gray-p">
        <NumberFormat
          customInput={TextField}
          className="rightToLeft showData"
          inputProps={{
            maxLength: 40
          }}
          disabled
          value={(newdata !== 0 && newdata !== "" && newdata !== "0.0" && newdata !== null) ? Number(newdata) : ''}
          thousandSeparator='.'
          decimalSeparator=","
          decimalScale='2'
        />
      </TableCell>
    )
  }

  render() {
    const { monthPlans, userData, reportSelect, monthPlanPdf, monthPlanSheet } = this.state
    const { isloading } = this.props
    const objectArray = Object.entries(monthPlans && (reportSelect === "dayssold" ?  monthPlans.report : monthPlans.assigned));
    const userDataArray = Object.entries(userData ? userData[0] : '');
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    let userList = []
    let projectPlans = [] 
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div className="plainingTab plainingTab-1 plainingTab-top-sticky">
        {isloading && <OverLoader />}
        {Number(access_rights.months_plan) !== 0 ?
          <div className="plainingTable">
            <TextField
              value={reportSelect}
              style={{ padding: "10px 0" }}
              select
              variant="outlined"
              className="select-box"
              size="small"
              onChange={(e) => {
                this.props.GetMonthPlansPDF(e.target.value)
                this.props.GetMonthPlanSheet(e.target.value)
                this.setState({ reportSelect: e.target.value, monthPlanPdf: '', monthPlanSheet: '' })
              }}
            >
              <MenuItem value={'dayssold'}>verkaufte Tage</MenuItem>
              <MenuItem value={'daysassigned'}>vergebene Tage</MenuItem>
            </TextField>
            {!isEmpty(monthPlanPdf) ?
              <Button variant="outlined" color="primary"
                style={{ marginLeft: "10px", marginTop: "10px" }}
                onClick={() => {
                  const theLink = document.createElement('a');
                  theLink.href = monthPlanPdf;
                  theLink.download = `6_Monatsplan ${reportSelect === "dayssold" ? "(verkaufte)" : "(vergebene)"}.pdf`;
                  document.body.appendChild(theLink);
                  theLink.click();
                  document.body.removeChild(theLink);
                }
                }
              >Drucken</Button> :
              <span style={{
                padding: "17px",
                display: "inline-block"
              }}>Preparing PDF...</span>
            }
            {!isEmpty(monthPlanSheet) ?
                <Button variant="outlined" color="primary"
                        style={{ marginLeft: "10px", marginTop: "10px" }}
                        onClick={() => {
                          const theLink = document.createElement('a');
                          theLink.href = monthPlanSheet;
                          theLink.download = `6_Monatsplan ${reportSelect === "dayssold" ? "(verkaufte)" : "(vergebene)"}.xlsx`;
                          document.body.appendChild(theLink);
                          theLink.click();
                          document.body.removeChild(theLink);
                        }
                        }
                >Excel</Button> :
                <span style={{
                  padding: "17px",
                  display: "inline-block"
                }}>Preparing Sheet...</span>
            }
            <Grid container spacing={0} className="skm">
              <Grid item xs={2}>
                <div className="stickyHeader stickyHeader-1">
                  <div className="pl-heading">
                    {reportSelect === "dayssold" ? "verkaufte Tage" : "vergebene Tage"}
                  </div>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <TableRow className="pl-heading">
                          <TableCell>Branche | Projekt</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div style={{ display: "flex" }}>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        {objectArray &&
                        objectArray.map(([key, value]) => {
                          let plansKey = key
                            const branches = Object.entries(value);
                            return (
                              <Fragment key={key}>
                                { key !== "2" &&
                                <TableRow className="blue">
                                  <TableCell>{reportSelect === "dayssold" ? (key === "0" ? "Extern" : "Planprojekte") : (key === "0" ? "Extern" : "Intern")}</TableCell>
                                </TableRow>}
                                {branches.map(([key, value]) => {
                                  let projects = []
                                  if (!key.includes("Summe")) {
                                    projects = Object.entries(value);
                                  }
                                  return (
                                    <Fragment key={key}>
                                      <TableRow className={`${key.includes("Summe") ? "blue" : "light-blue"} ${(key.includes("zzz_external Summe") || key.includes("zzz_internal Summe") || key.includes("zzz_total Summe")) && "gray-p"}`}>
                                        {key.includes("zzz_total Summe") &&
                                          <TableCell className="pl-2">Gesamtsumme</TableCell>
                                        } 
                                        {key.includes("zzz_external Summe") &&
                                          <TableCell className="pl-2">{(plansKey === '1' && reportSelect === "dayssold") ? "Planprojekte Summe" : "Extern Summe" }</TableCell>
                                        }
                                        {key.includes("zzz_internal Summe") &&
                                          <TableCell className="pl-2">Intern Summe</TableCell>
                                        }
                                        {((reportSelect === "dayssold" && plansKey === "0") || reportSelect === "daysassigned")  && !(key.includes("zzz_external Summe") || key.includes("zzz_internal Summe")) &&
                                          <TableCell className="pl-2">{key}</TableCell>
                                        }
                                      </TableRow>
                                      {projects.map(([key, value]) => {
                                        return (
                                          <TableRow key={key}>
                                            <TableCell className="light-gray-p pl-3">{value[0].projectno + " " + value[0].projectname}</TableCell>
                                          </TableRow>
                                        )
                                      })}
                                    </Fragment>
                                  )
                                })
                                }
                              </Fragment>
                            )
                          })
                        }
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </Grid>
              <Grid item xs={10} className="x-scroll">
                <div className="stickyHeader">
                  {userDataArray &&
                    userDataArray.map(([key, value]) => {
                      userList = Object.entries(value);
                      return (
                        <div key={key} className="inner-month">
                          <div className="pl-heading">
                            <span className="value">
                              {moment(key).format("MM-YYYY")}
                            </span>
                          </div>
                          <TableContainer>
                            <Table size="small">
                              <TableBody>
                                <TableRow className="pl-heading">
                                  {userList.map(([key, value]) => {
                                    const userName = Object.entries(value);
                                    return userName.map(([key, value]) => {
                                      return (
                                        <TableCell align="center" key={key}><span className="value">{value[0].login_name.substring(0, 4)}{value[0].login_name.length > 4 ? '...' : ''}</span> </TableCell>
                                      )
                                    })
                                  })}
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      )
                    })
                  }
                </div>

                <div style={{ display: "flex" }}>
                  {userDataArray &&
                    userDataArray.map(([key, value]) => {
                      userList = Object.entries(value);
                      return (
                        <div key={key} className="inner-month">
                          <TableContainer>
                            <Table size="small">
                              <TableBody>
                                {objectArray &&
                                  objectArray.map(([key, value]) => {
                                    let plansKey = key
                                    const branches = Object.entries(value);
                                    return (
                                      <Fragment key={key}>
                                        { key !== "2" &&
                                          <TableRow className="blue">
                                            {userList.map(([key, value]) => {
                                              const userName = Object.entries(value);
                                              return userName.map(([key, value]) => {
                                                return (
                                                  <TableCell key={key} ></TableCell>
                                                )
                                              })
                                            })}
                                          </TableRow>}
                                        {branches.map(([key, value]) => {
                                          let projects = []
                                          let projectSummary = []
                                          if (!key.includes("Summe")) {
                                            projects = Object.entries(value);
                                          } else {
                                            projectSummary = Object.entries(value)
                                          }
                                          return (
                                            <Fragment key={key}>
                                              {((plansKey === "1" && key.includes("zzz_external Summe")) || (plansKey === "2") || (plansKey === "0") || reportSelect==="daysassigned") &&
                                                <TableRow className={`${key.includes("Summe") ? "blue" : "light-blue"} ${(key.includes("zzz_external Summe") || key.includes("zzz_internal Summe") || key.includes("zzz_total Summe")) && "gray-p"}`}>
                                                  {userList.map(([key, value]) => {
                                                    const userName = Object.entries(value);
                                                    return userName.map(([key, value]) => {
                                                      return this.plansData(value, projectSummary)
                                                    })
                                                  })}
                                                </TableRow>
                                              }
                                              {projects.map(([key, value]) => {
                                                projectPlans = Object.entries(value[0].project_plans);
                                                return (
                                                  <TableRow key={key}>
                                                    {userList.map(([key, data]) => {
                                                      const userName = Object.entries(data);
                                                      return userName.map(([key, data]) => {
                                                        return this.plansData(data, projectPlans)

                                                      })
                                                    })}
                                                  </TableRow>
                                                )
                                              })}
                                            </Fragment>
                                          )
                                        })
                                        }
                                      </Fragment>
                                    )

                                  })
                                }

                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                      )
                    })
                  }
                </div>

              </Grid>
            </Grid>
          </div>
          :
          <Grid item md={12} sm={12} xs={12}>
            <div className="rightBlock rightBlock-bgWhite user-system">
              <h3>Access Denied</h3>
            </div>
          </Grid>
        }
      </div>
    )
  }
}

const mapStateToProps = ({ monthPlan }) => {
  return {
    month_plans: monthPlan.month_plans,
    user_data: monthPlan.user_data,
    isloading: monthPlan.loading,
    month_plan_pdf: monthPlan.month_plan_pdf,
    month_plan_sheet: monthPlan.month_plan_sheet
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetMonthPlans: (val) => dispatch(GetMonthPlans(val)),
    GetMonthPlansPDF: (val) => dispatch(GetMonthPlansPDF(val)),
    GetMonthPlanSheet: (val) => dispatch(GetMonthPlanSheet(val)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(MontPlans)